// import {
//     Card,
//     Row,
//     Col,
//     List,
//     Timeline,
//     Badge,
//     Tag,
//     Flex,
//     Tooltip,
//   } from "antd";
//   import { useEffect, useState } from "react";
//   import classes from "./command.module.scss";
//   import { Typography } from "antd";
//   import RadarChart from "./RadarChart";
//   const { Title, Text, Paragraph } = Typography;

//   const CommandSystemCmp = () => {
//     // Dummy Data
//     const radarPointsRisk = [
//       {
//         title: "Hidden Client Churn Signal (Pattern Detection)",
//         risk: "3 mid-tier clients haven’t submitted a support ticket or invoice payment in 21+ days — historically, this pattern precedes churn within 30 days.",
//         trigger: "Detected drop in Stripe activity + Asana ticket silence.",
//         impact: "$22,000/month at risk ",
//         mitigation: [
//           "Flagged AMs in Slack",
//           "Pre-written re-engagement emails deployed",
//           "Tasks scheduled for check-in calls",
//         ],
//       },
//       {
//         title: "Undetected Scope Creep Breach in Active Project",
//         risk: "The “Buildify Migration” project has exceeded 28% more engineer hours than scoped — billable overages not being tracked.",
//         trigger: "Asana task overages + QuickBooks time entries mismatched",
//         impact: "Margin loss + potential client conflict",
//         mitigation: [
//           "Slack alert to PM",
//           "Scope audit task deployed",
//           "Email template pre-filled to client re: amendment",
//         ],
//       },
//       {
//         title: "Burnout Spike Among Tier-1 Engineers",
//         risk: "Two engineers have completed 37% more tickets than team average for three consecutive weeks — no PTO scheduled.",
//         trigger: "Asana velocity pattern",
//         impact: "Retention risk + SLA degradation",
//         mitigation: [
//           "PTO recommendation generated",
//           "Workload redistributed",
//           "HR follow-up scheduled",
//         ],
//       },
//       {
//         title: "Security Risk: Unpatched Vulnerability Across 6 Clients",
//         risk: "Missed security patch reported in 6 client environments — tied to a new CVE released this week.",
//         trigger: "Cross-match from support tickets + CVE feed",
//         impact: "Potential breach exposure + legal risk",
//         mitigation: [
//           "Security playbook auto-deployed",
//           "Jira tasks created for patch rollout",
//           "Legal disclaimer alert drafted for optional disclosure",
//         ],
//       },
//     ];

//     const radarPointsOpportunity = [
//       {
//         title: "Emerging Trend in Security = Product Expansion",
//         oppurnity:
//           "23% rise in SMB clients requesting endpoint monitoring over past 60 days.",
//         trigger: "Ticket keyword clustering",
//         impact: "$140K projected ARR from add-on",
//         execution: [
//           "New service package drafted",
//           "Marketing page skeleton created in Notion",
//           "Pilot outreach to 5 active clients launched",
//         ],
//       },
//       {
//         title: "Missed Upsell: 12 Clients on Starter Plan Using Premium Features",
//         oppurnity:
//           "Feature usage shows 12 clients exceeding limits but haven’t upgraded.",
//         trigger: "Internal usage logs + QBO billing mismatch",
//         impact: "$3,600/mo lost revenue",
//         execution: [
//           "Upgrade email sent",
//           "Account managers pinged",
//           "Stripe SKU swap automation triggered",
//         ],
//       },
//       {
//         title: "Competitor Exit Creates Opening for Strategic Takeover",
//         oppurnity:
//           "Regional competitor “EdgeSecure” shut down — 18 known shared clients now vendorless.",
//         trigger: "RSS scrape + CRM match",
//         impact: "$72K potential new revenue",
//         execution: [
//           "Pre-drafted LinkedIn outreach sent",
//           "Competitor switch-over checklist generated",
//           "Sales leader brief auto-created",
//         ],
//       },
//       {
//         title: "Referral Spike Pattern Detected",
//         oppurnity:
//           "3 client referrals logged in past week — correlated to NPS survey surge",
//         trigger: "CRM + Survey tool merge",
//         impact: "Viral momentum potential",
//         execution: [
//           "Referral rewards page auto-published",
//           "Emails sent to top 5 promoters",
//           "Slack message to sales: “Lean in — trend spotted”",
//         ],
//       },
//     ];

//     const autoExecuted = [
//       { id: 1, title: "Auto-Patch Applied", priority: "Critical" },
//       { id: 2, title: "Vendor SLA Issue", priority: "High" },
//       { id: 3, title: "Firewall Breach Attempt", priority: "Critical" },
//       { id: 4, title: "Unauthorized Access Prevented", priority: "Medium" },
//     ];

//     const initialMissionStack = [
//       { id: 2, x: 30, y: 40, type: "Opportunity" },
//       { id: 3, x: 25, y: 15, type: "Risk" },
//     ];

//     const initialFeed = [
//       "System Boot Successful",
//       "Scheduled Scan Started",
//       "Detected Risk: SQL Injection Attempt",
//       "Auto-executed: Applied Firewall Rule",
//       "Detected Opportunity: SLA Optimization",
//       "Mission Added: SQL Injection",
//       "Auto-executed: Vendor SLA Issue",
//       "Detected Risk: Malware Signature",
//       "User Executed Mission: Patch Deployment",
//       "Detected Risk: Ransomware Pattern",
//       "Auto-executed: Suspicious IP Blocked",
//       "Mission Added: Malware Mitigation",
//     ];

//     const [time, setTime] = useState(new Date());
//     const [missionStack, setMissionStack] = useState(initialMissionStack);
//     const [feed, setFeed] = useState(initialFeed);

//     useEffect(() => {
//       const timer = setInterval(() => setTime(new Date()), 1000);
//       return () => clearInterval(timer);
//     }, []);

//     return (
//       <>
//         {" "}
//         <div className={classes.header}>
//           <Title level={4} style={{ marginTop: 0 }}>
//             Radar+
//           </Title>
//           <Text type="secondary" style={{ fontSize: 12 }}>
//             The Radar+ serves as a live command center, providing
//             real-time monitoring and actionable controls. It offers instant
//             visibility into system status, events, and operations, allowing users
//             to proactively manage activities, respond to incidents, and execute
//             critical actions directly from a centralized dashboard. Designed for
//             efficiency and responsiveness, it ensures teams can maintain full
//             situational awareness and take immediate, informed decisions when
//             needed.
//           </Text>
//         </div>
//         <div style={{ padding: "20px" }}>
//           <Row gutter={[16, 16]}>
//             <Col span={24}>
//               <Card title="System Status on Radar" className={"radarContainer"}>
//                 <RadarChart />
//                 <div>
//                   <div
//                     style={{
//                       flexDirection: "column",
//                       display: "flex",
//                       gap: 15,
//                       height: "100%",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <div>
//                       <Title level={5} style={{ color: "white" }}>
//                         Top 4 Risks
//                       </Title>

//                       <Flex gap="10px 0" wrap>
//                         {radarPointsRisk.map((item, index) => (
//                           <Tooltip
//                             title={
//                               <div
//                                 style={{ backgroundColor: "black", padding: 5 }}
//                               >
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Risk:{" "}
//                                 </Title>
//                                 <Paragraph style={{ color: "white" }}>
//                                   {item.risk}
//                                 </Paragraph>
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Trigger:{" "}
//                                 </Title>
//                                 <Paragraph style={{ color: "white" }}>
//                                   {item.trigger}
//                                 </Paragraph>
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Impact:{" "}
//                                 </Title>
//                                 <Paragraph style={{ color: "white" }}>
//                                   {item.impact}
//                                 </Paragraph>
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Auto Execution{" "}
//                                 </Title>
//                                 <List
//                                   size="small"
//                                   bordered
//                                   dataSource={item.mitigation}
//                                   renderItem={(item) => (
//                                     <List.Item style={{ color: "white" }}>
//                                       {item}
//                                     </List.Item>
//                                   )}
//                                 />
//                               </div>
//                             }
//                           >
//                             <Tag
//                               key={`${index}-risk`}
//                               bordered={false}
//                               color="error"
//                             >
//                               {item.title}
//                             </Tag>
//                           </Tooltip>
//                         ))}
//                       </Flex>
//                     </div>
//                     <div>
//                       <Title level={5} style={{ color: "white" }}>
//                         Top 4 Opportunities
//                       </Title>

//                       <Flex gap="10px 0" wrap>
//                         {radarPointsOpportunity.map((item, index) => (
//                           <Tooltip
//                             title={
//                               <div
//                                 style={{ backgroundColor: "black", padding: 5 }}
//                               >
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Risk:{" "}
//                                 </Title>
//                                 <Paragraph style={{ color: "white" }}>
//                                   {item.risk}
//                                 </Paragraph>
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Trigger:{" "}
//                                 </Title>
//                                 <Paragraph style={{ color: "white" }}>
//                                   {item.trigger}
//                                 </Paragraph>
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Impact:{" "}
//                                 </Title>
//                                 <Paragraph style={{ color: "white" }}>
//                                   {item.impact}
//                                 </Paragraph>
//                                 <Title level={5} style={{ color: "white" }}>
//                                   Auto Mitigation{" "}
//                                 </Title>
//                                 <List
//                                   size="small"
//                                   bordered
//                                   dataSource={item.execution}
//                                   renderItem={(item) => (
//                                     <List.Item style={{ color: "white" }}>
//                                       {item}
//                                     </List.Item>
//                                   )}
//                                 />
//                               </div>
//                             }
//                           >
//                             <Tag color="green" key={`${index}-opp`}>
//                               {item.title}
//                             </Tag>
//                           </Tooltip>
//                         ))}
//                       </Flex>
//                     </div>
//                   </div>
//                 </div>
//               </Card>
//             </Col>
//             <Col span={12}>
//               <Card title="System Status">
//                 <p>
//                   <Badge status="success" /> SYSTEM ON
//                 </p>
//                 <p>Last Scan: {time.toLocaleTimeString()}</p>
//                 <p>
//                   Next Scan:{" "}
//                   {new Date(time.getTime() + 60000).toLocaleTimeString()}
//                 </p>
//                 <p>System Uptime: 2 hours 30 minutes</p>
//                 <p>Last Update: {time.toLocaleTimeString()}</p>
//                 <p>System Version: 1.0.0</p>
//                 <p>System Load: 45%</p>
//               </Card>
//             </Col>
//             <Col span={12}>
//               <Card title="Auto-Executed Missions">
//                 <List
//                   size="small"
//                   dataSource={autoExecuted}
//                   renderItem={(item) => (
//                     <List.Item>
//                       <Badge
//                         status={
//                           item.priority === "Critical" ? "error" : "warning"
//                         }
//                         style={{ marginRight: 8 }}
//                       />
//                       {item.title} ({item.priority})
//                     </List.Item>
//                   )}
//                 />
//               </Card>
//             </Col>

//             <Col span={6}>
//               <Card
//                 title="Mission Control (Selected Targets)"
//                 style={{ height: 350, overflowY: "auto" }}
//               >
//                 <List
//                   size="small"
//                   dataSource={missionStack}
//                   renderItem={(item) => (
//                     <List.Item>
//                       <Badge
//                         status={item.type === "Risk" ? "error" : "processing"}
//                         style={{ marginRight: 8 }}
//                       />
//                       {item.type} at ({item.x},{item.y})
//                     </List.Item>
//                   )}
//                 />
//               </Card>
//             </Col>

//             <Col span={18}>
//               <Card
//                 title="System Feed (Live Logs)"
//                 style={{ height: 750, overflowY: "auto" }}
//               >
//                 <Timeline>
//                   {feed.map((entry, idx) => (
//                     <Timeline.Item key={idx}>{entry}</Timeline.Item>
//                   ))}
//                 </Timeline>
//               </Card>
//             </Col>
//           </Row>
//         </div>
//       </>
//     );
//   };
//   export default CommandSystemCmp;

import { useState, useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Activity, TrendingUp, Zap, CheckCircle, Radio, MessageSquare, FileText, Flag } from "lucide-react"
import RadarDisplay from "./RadarDisplay"
import { useMutation } from "@tanstack/react-query"
import { getSignals } from "../../services/signalService";
import { message } from "antd"

export default function CommandSystemCmp() {
  const [logs, setLogs] = useState([])
  const [liveSignals, setLiveSignals] = useState([])
  const [selectedLog, setSelectedLog] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const signalMutation = useMutation({
    mutationFn: getSignals,
    onSuccess: (response) => {
      if (response?.data?.results) {
        setLogs(response.data.results);
        setIsLoading(false);
      }
    },
    onError: (error) => {
      message.error(error);
      setIsLoading(false);
    },
  });
  useEffect(() => {

    const initialLiveSignals = [
      { id: "1", type: "opportunity", message: 'Early-stage opportunity: "AI Security Trend"', icon: "🔵" },
      { id: "2", type: "risk", message: 'High-risk alert: "Regulatory Warning - Finance"', icon: "🔴" },
      { id: "3", type: "stable", message: 'Stable: "Customer Feedback Spike"', icon: "🟢" },
    ]
    setLiveSignals(initialLiveSignals)
  }, []);

  const getPriorityIcon = (score) => {
  if (score >= 85) return '🔴 Critical';
  if (score >= 70) return '🟠 High';
  if (score >= 50) return '🟡 Medium';
  return '🟢 Low';
};

  useEffect(() => {
    setIsLoading(true)
    signalMutation.mutate();
    const interval = setInterval(() => {
      signalMutation.mutate();
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {isLoading ? (    <div className="w-full h-screen flex items-center justify-center bg-gray-100">
      <div className="text-gray-600 font-mono text-lg">Loading...</div>
    </div>) : (
      <div className="w-full h-screen bg-transparent text-gray-800 font-mono overflow-hidden relative flex flex-col">
        {/* ENGINE ACTIVE Badge */}
        <motion.div
          className="absolute top-4 right-4 z-50 bg-green-500/20 border border-green-500 px-3 py-1 rounded text-xs text-green-700"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
        >
          <Radio className="inline w-3 h-3 mr-1" />
          ENGINE ACTIVE
        </motion.div>

        <div className="grid grid-cols-12 h-full flex-1 min-h-0">
          {/* Left Panel - Autonomous Response Stream */}
          <div className="col-span-3 border-r border-gray-300 p-4 flex flex-col overflow-hidden bg-gray-50 ">
            <div className="mb-4 flex-shrink-0">
              <h2 className="text-sm font-bold text-gray-700 mb-2 border-b border-gray-300 pb-1">
                AUTONOMOUS RESPONSE STREAM
              </h2>
            </div>
            <div className="flex-1 overflow-hidden overflow-y-auto space-y-2">
              <AnimatePresence>
                {logs?.map((log, index) => {
                  const IconComponent =
                    {
                      MessageSquare,
                      CheckCircle,
                      FileText,
                      Flag,
                      Zap,
                      TrendingUp,
                      Activity,
                    }[log.toolIcon] || Activity

                  return (
                    <motion.div
                      key={log.id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{
                        opacity: index < 50 ? 1 : 0,
                        x: 0,
                      }}
                      exit={{ opacity: 0, x: -20 }}
                      className="p-3 text-xs bg-gray-200 border-2 border-green-500 rounded-lg shadow-lg hover:shadow-xl transition-all cursor-pointer hover:bg-gray-100 hover:border-green-600"
                      style={{
                        boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3), 0 0 0 1px rgba(34, 197, 94, 0.4)",
                      }}
                      onClick={(e) => {
                        setSelectedLog(log)
                      }}
                    >
                      <div className="flex items-start gap-2 flex-wrap">
                        <span className="text-gray-600 flex-shrink-0 font-semibold">[{log.timestamp?.split("T")[1]?.split(".")[0]}]</span>
                        <div className="flex items-center gap-1 flex-shrink-0">
                          <IconComponent
                            className={`w-3 h-3 flex-shrink-0 ${log.signal_type.includes('Opportunity')
                              ? "text-green-600"
                              : log.signal_type.includes('Alert')
                                ? "text-yellow-600"
                                : "text-blue-600"
                              }`}
                          />
                          <span className="w-[90%] truncate text-green-700 font-medium whitespace-normal overflow-hidden">
                            {log.signal_type}
                          </span>
                        </div>
                        <span className="text-green-600 flex-shrink-0">→</span>
                        <span className="text-gray-700 break-words">
                          {log.raw_signal}
                        </span>
                      </div>
                    </motion.div>
                  )
                })}
              </AnimatePresence>
            </div>
          </div>

          {/* Center - Radar Display */}
          <div className="col-span-6 flex items-center justify-center p-4 bg-transparent">
            <RadarDisplay logs={logs} />
          </div>

          {/* Right Panel - Impact & Metrics */}
          <div className="col-span-3 border-l border-gray-300 p-4 flex flex-col overflow-hidden bg-gray-50">
            <div className="mb-4 flex-shrink-0">
              <h2 className="text-sm font-bold text-gray-700 mb-2 border-b border-gray-300 pb-1 pt-7">
                RISK/OPPORTUNITY IMPACT READOUT
              </h2>
            </div>
            <div className="flex-1 overflow-y-auto space-y-4">
              {/* Risks Resolved */}
              <motion.div
                className="p-3 border border-green-400 rounded bg-green-50 flex-shrink-0"
                animate={{
                  borderColor: ["rgba(34, 197, 94, 0.4)", "rgba(34, 197, 94, 0.8)", "rgba(34, 197, 94, 0.4)"],
                  boxShadow: [
                    "0 0 5px rgba(34, 197, 94, 0.3)",
                    "0 0 15px rgba(34, 197, 94, 0.5)",
                    "0 0 5px rgba(34, 197, 94, 0.3)",
                  ],
                }}
                transition={{ duration: 3, repeat: Number.POSITIVE_INFINITY }}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-green-600 text-lg">✅</span>
                  <div className="text-xs text-gray-700 font-medium">Risks Resolved</div>
                </div>
                <div className="text-2xl font-bold text-green-600">3</div>
                <div className="flex gap-1 mt-2">
                  {[1, 2, 3].map((i) => (
                    <motion.div
                      key={i}
                      className="h-1 bg-green-500 rounded-full flex-1"
                      initial={{ scaleX: 0 }}
                      animate={{ scaleX: 1 }}
                      transition={{ duration: 0.5, delay: i * 0.2 }}
                    />
                  ))}
                </div>
              </motion.div>

              {/* Forecast Value Protected */}
              <motion.div
                className="p-3 border border-blue-400 rounded bg-blue-50 flex-shrink-0"
                animate={{
                  borderColor: ["rgba(59, 130, 246, 0.4)", "rgba(59, 130, 246, 0.8)", "rgba(59, 130, 246, 0.4)"],
                  boxShadow: [
                    "0 0 5px rgba(59, 130, 246, 0.3)",
                    "0 0 15px rgba(59, 130, 246, 0.5)",
                    "0 0 5px rgba(59, 130, 246, 0.3)",
                  ],
                }}
                transition={{ duration: 2.5, repeat: Number.POSITIVE_INFINITY }}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-blue-600 text-lg">📈</span>
                  <div className="text-xs text-gray-700 font-medium">Forecast Value Protected</div>
                </div>
                <div className="text-2xl font-bold text-blue-600">$28.9K</div>
                <div className="w-full bg-blue-200 rounded-full h-2 mt-2">
                  <motion.div
                    className="bg-gradient-to-r from-blue-500 to-blue-400 h-2 rounded-full"
                    initial={{ width: 0 }}
                    animate={{ width: "89%" }}
                    transition={{ duration: 2, ease: "easeOut" }}
                  />
                </div>
              </motion.div>

              {/* Strategic Confidence Score */}
              <motion.div
                className="p-3 border border-green-400 rounded bg-green-50 flex-shrink-0"
                animate={{
                  borderColor: ["rgba(34, 197, 94, 0.4)", "rgba(34, 197, 94, 0.9)", "rgba(34, 197, 94, 0.4)"],
                  boxShadow: [
                    "0 0 5px rgba(34, 197, 94, 0.3)",
                    "0 0 20px rgba(34, 197, 94, 0.6)",
                    "0 0 5px rgba(34, 197, 94, 0.3)",
                  ],
                }}
                transition={{ duration: 4, repeat: Number.POSITIVE_INFINITY }}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-green-600 text-lg">🎯</span>
                  <div className="text-xs text-gray-700 font-medium">Strategic Confidence Score</div>
                </div>
                <div className="text-2xl font-bold text-green-600">92%</div>
                <div className="flex gap-1 mt-2">
                  {Array.from({ length: 10 }, (_, i) => (
                    <motion.div
                      key={i}
                      className={`h-2 rounded-full flex-1 ${i < 9 ? "bg-green-500" : "bg-gray-300"}`}
                      initial={{ scaleY: 0 }}
                      animate={{ scaleY: 1 }}
                      transition={{ duration: 0.3, delay: i * 0.1 }}
                    />
                  ))}
                </div>
              </motion.div>

              {/* Response Time */}
              <motion.div
                className="p-3 border border-yellow-400 rounded bg-yellow-50 flex-shrink-0"
                animate={{
                  borderColor: ["rgba(234, 179, 8, 0.4)", "rgba(234, 179, 8, 0.8)", "rgba(234, 179, 8, 0.4)"],
                  boxShadow: [
                    "0 0 5px rgba(234, 179, 8, 0.3)",
                    "0 0 15px rgba(234, 179, 8, 0.5)",
                    "0 0 5px rgba(234, 179, 8, 0.3)",
                  ],
                }}
                transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-yellow-600 text-lg">⚡</span>
                  <div className="text-xs text-gray-700 font-medium">Response Time</div>
                </div>
                <div className="text-2xl font-bold text-yellow-600">8.2 sec</div>
                <div className="relative w-full bg-yellow-200 rounded-full h-2 mt-2">
                  <motion.div
                    className="bg-gradient-to-r from-yellow-500 to-yellow-400 h-2 rounded-full"
                    initial={{ width: 0 }}
                    animate={{ width: "35%" }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                  />
                  <div className="absolute right-0 top-0 h-2 w-1 bg-green-500 rounded-full" />
                </div>
              </motion.div>

              {/* New Signal Types Detected */}
              <motion.div
                className="p-3 border border-purple-400 rounded bg-purple-50 flex-shrink-0"
                animate={{
                  borderColor: ["rgba(168, 85, 247, 0.4)", "rgba(168, 85, 247, 0.8)", "rgba(168, 85, 247, 0.4)"],
                  boxShadow: [
                    "0 0 5px rgba(168, 85, 247, 0.3)",
                    "0 0 15px rgba(168, 85, 247, 0.5)",
                    "0 0 5px rgba(168, 85, 247, 0.3)",
                  ],
                }}
                transition={{ duration: 3.5, repeat: Number.POSITIVE_INFINITY }}
              >
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-purple-600 text-lg">💡</span>
                  <div className="text-xs text-gray-700 font-medium">New Signal Types Detected</div>
                </div>
                <div className="text-2xl font-bold text-purple-600">2</div>
                <div className="flex gap-2 mt-2">
                  <motion.div
                    className="w-3 h-3 bg-purple-500 rounded-full"
                    animate={{
                      scale: [1, 1.3, 1],
                      opacity: [0.7, 1, 0.7],
                    }}
                    transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY }}
                  />
                  <motion.div
                    className="w-3 h-3 bg-purple-500 rounded-full"
                    animate={{
                      scale: [1, 1.3, 1],
                      opacity: [0.7, 1, 0.7],
                    }}
                    transition={{ duration: 2, repeat: Number.POSITIVE_INFINITY, delay: 0.5 }}
                  />
                  <div className="w-3 h-3 bg-gray-300 rounded-full" />
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Bottom Panel - Live Signal Feed */}
        <div className="border-t border-gray-300 bg-gray-100 p-4 flex-shrink-0">
          <h3 className="text-sm font-bold text-gray-700 mb-2">INCOMING SIGNALS</h3>
          <div className="flex gap-6 overflow-x-auto">
            {liveSignals.map((signal, index) => (
              <motion.div
                key={signal.id}
                className={`flex items-center gap-2 text-xs whitespace-nowrap ${signal.type === "opportunity"
                    ? "text-blue-600"
                    : signal.type === "risk"
                      ? "text-red-600"
                      : "text-green-600"
                  }`}
                animate={{ opacity: [0.6, 1, 0.6] }}
                transition={{
                  duration: 3,
                  repeat: Number.POSITIVE_INFINITY,
                  delay: index * 0.5,
                }}
              >
                <span className="text-lg">{signal.icon}</span>
                <span>{signal.message}</span>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Modal */}
        {selectedLog && (
          <>
            {/* Backdrop */}
            <div className="fixed inset-0 bg-black/20 z-40" onClick={() => setSelectedLog(null)} />

            {/* Modal */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9, x: -20 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              exit={{ opacity: 0, scale: 0.9, x: -20 }}
              className="fixed z-50 left-[38%] top-[30%] transform -translate-x-[38%] -translate-y-[30%] bg-white border-2 border-green-400 rounded-lg shadow-2xl p-6 min-w-[300px] max-w-[400px] overflow-hidden overflow-y-auto"
              style={{
                boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(34, 197, 94, 0.3)",
              }}
            >
              {/* Close button */}
              <button
                onClick={() => setSelectedLog(null)}
                className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl font-bold"
              >
                ×
              </button>

              {/* Modal content */}
              <div className="space-y-4 overflow-hidden overflow-y-auto max-h-[60vh]">
                <div className="border-b border-gray-200 pb-3">
                  <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                    {(() => {
                      const IconComponent =
                        {
                          MessageSquare,
                          CheckCircle,
                          FileText,
                          Flag,
                          Zap,
                          TrendingUp,
                          Activity,
                        }[selectedLog.toolIcon] || Activity
                      return <IconComponent className="w-5 h-5 text-green-600" />
                    })()}
                    {selectedLog.tool} Details
                  </h3>
                </div>

                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">Timestamp:</span>
                    <span className="text-gray-800 font-mono">{selectedLog.timestamp}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">Action:</span>
                    <span className="text-gray-800">{selectedLog.action}</span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">Status:</span>
                    <span
                      className={`px-2 py-1 rounded text-xs font-bold ${selectedLog.signal_type.includes("Opportunity")
                        ? "bg-green-100 text-green-700"
                        : selectedLog.signal_type.includes("Alert")
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-blue-100 text-blue-700"
                        }`}
                    >
                      {selectedLog.signal_type?.toUpperCase()}
                    </span>
                  </div>

                  <div>
                    <span className="text-gray-600 font-medium">Description:</span>
                    <p className="text-gray-800 mt-1">{selectedLog.enrichment}</p>
                  </div>

                  <div className="border-t border-gray-200 pt-3">
                    <span className="text-gray-600 font-medium">Additional Info:</span>
                    <div className="mt-2 space-y-1 text-xs">
                      <div className="flex justify-between">
                        <span>Priority Level:</span>
                        <span className="font-medium">
                          
                          {getPriorityIcon(selectedLog.score)}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Auto-Response:</span>
                        <span className="font-medium text-green-600">Enabled</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Impact Score:</span>
                        <span className="font-medium">{selectedLog.score}/100</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </div>
    )}
    </>
  )
}



